/**
 * True if `held` contains at least one of the `required` permission ids.
 *
 * `required` is a single permission id or an array meaning "any of these" (e.g. the import
 * tool's five per-import permissions, #1502). This centralises the membership check that the
 * route guard, the admin tile, the import-tool button filter and the dashboard tabs each used
 * to re-implement — and previously disagreed on.
 *
 * Note on the "no requirement" case: whether an *absent* requirement means allow or deny is
 * deliberately NOT decided here because it is contextual — a route with no `data.permission`
 * is unrestricted (allow), whereas an admin tile with no permission is hidden (deny). Each
 * caller resolves that explicitly before delegating the membership test to this function, so
 * the policy is intentional at the call site rather than an accidental side effect of the
 * shared helper.
 */
export function hasAnyPermission(held: number[], required: number | number[]): boolean {
  if (!held?.length) {
    return false;
  }
  const requiredIds = Array.isArray(required) ? required : [required];
  return requiredIds.some((id) => held.includes(id));
}
